import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';
import { RootState } from '../store';

export const getPois = createAsyncThunk('poi/get', async () => {
    const response = await axios.get('pois', { params: { teamId: 0 } });

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getTagData = createAsyncThunk('poi/get-data', async ({ id }: { id: number }) => {
    const response = await axios.get(`pois/${id}`);

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getPoisInArea = createAsyncThunk('poi/get-arean', async ({ area }: { area: string }) => {
    const response = await axios.get(`pois?area=${area}`);

    // console.log('getPoisInArea', response.data);
    if (response.status === 200 && typeof response.data === 'object' && response.data.status == 200) {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getAllPois = createAsyncThunk('poi-all/get', async (_, { getState }) => {
    const state = getState() as RootState;
    const { teams, sharedTeams } = state.team;
    let teamsIds = '';
    let teamIds: number[] = [];
    let sharedTeamIds: number[] = [];

    if (Array.isArray(teams)) {
        teamIds = teams.filter((t) => t.id !== undefined).map((t) => t.id);
    }

    if (Array.isArray(sharedTeams)) {
        sharedTeamIds = sharedTeams.filter((t) => t.id !== undefined).map((t) => t.id);
    }

    const combinedIds = [...new Set([...teamIds, ...sharedTeamIds])];

    teamsIds = combinedIds.join(',');

    const response = await axios.get('pois-all', { params: { teamsIds } });

    // console.log('response', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const createPoi = createAsyncThunk('poi/create', async ({ body }: { body: FormData }) => {
    const response = await axios.post('pois', body);

    // console.log('createPoi', response.data, body);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});
